<template>
  <div>
    <v-card>
      <v-list-item class="mt-2">
        <v-list-item-avatar>
          <v-icon x-large :color="cliente.cor">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <v-icon small>mdi-account-circle</v-icon>
            {{ this.cliente.nome }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon small>mdi-phone</v-icon>
            <span> {{ this.cliente.celular | phone}}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <v-icon small>mdi-email</v-icon>
            <span> {{ this.cliente.email }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-subtitle v-if="!this.hasTags">
            <v-icon small>mdi-close-circle</v-icon>
            <span> Sem tags vinculadas.</span>
          </v-list-item-subtitle>
          <v-list-item-content v-if="this.hasTags">
            <div v-if="this.hasTags">
              <div align="left">
                <template v-for="tag in this.tags">
                  <v-tooltip
                    bottom
                    :key="tag.id"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-on="on"
                        v-bind="attrs"
                        small
                        v-text="tag.nome"
                        :color="tag.cor"/>
                    </template>
                    <span v-text="tag.nome"></span>
                  </v-tooltip>
                </template>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item-content>
        <v-list-item-action>
          <tw-cadastro-cliente @update="onUpdate" :cliente="this.cliente">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </tw-cadastro-cliente>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon small @click="onClickDelete(cliente)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
    <tw-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import CadastroCliente from '@/modules/cliente/CadastroCliente.vue';

export default {
  props: {
    cliente: Object,
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este cliente?',
        `O cliente ${item.nome} será removida e esta operação não pode ser desfeita.`,
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
  computed: {
    tags: {
      get() {
        if (this.cliente && this.cliente.tags) {
          return this.cliente.tags;
        }
        return [];
      },
    },
    hasTags: {
      get() {
        return this.tags.length > 0;
      },
    },
  },
  components: {
    TwCadastroCliente: CadastroCliente,
  },
};
</script>
